import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import API from "./apiInstance";
import { userRefreshToken } from "../helpers";

export const login = (postData) => {
  return axios.post(`${apiServicesUrl}/users/access-token`, postData);
};

export const logout = () => {
  return API.post(`${apiServicesUrl}/users/logout`, {
    refresh_token: userRefreshToken(),
  });
};

export const verifyOtp = (postData) => {
  return axios.post(`${apiServicesUrl}/users/verify_otp`, postData);
};

export const UserDetails = (postData) => {
  return axios.post(`${apiServicesUrl}/users/otp_method_details`, postData);
};

export const sendOtp = (postData) => {
  return axios.post(`${apiServicesUrl}/users/send_otp`, postData);
};